import { useRouteBodyState } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import type { ReferenceWordMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { SentenceRow } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.sentences._components.sentence-row";
import { useSentenceExamplesQueryOptions } from "@-/dev.improve.haniverse.lib.sentence";
import { useQuery } from "@-/com.npmjs.tanstack__react-query";
import { type ReactNode } from "react";
import { View } from "@-/com.npmjs.react-native";
import { hasLength } from "@-/com.npmjs.ts-array-length";

export function useMorphemeInfoPanelSentencesWordExamplesSection({
  wordCard,
}: {
  wordCard: ReferenceWordMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor {
  const [isOpen, setIsOpen] = useRouteBodyState(
    "use-morpheme-info-panel-sentences-word-examples-section.tsx:isOpen",
    true,
  );
  const front = wordCard.word;
  const { data: sentences, error, isLoading } = useQuery(useSentenceExamplesQueryOptions(front));

  let body: ReactNode;
  if (isLoading) {
    body = null;
  } else if (error) {
    body = (
      <View className="px-4 py-3">
        <Text className="text-sm text-destructive">Failed to load sentences: {error.message}</Text>
      </View>
    );
  } else if (!sentences || hasLength(sentences, 0)) {
    body = (
      <View className="px-4 py-3">
        <Text className="text-sm text-muted-foreground">No sentence examples for {front} yet.</Text>
      </View>
    );
  } else {
    body = sentences.map((sentence, index) => (
      <SentenceRow key={sentence.id} sentence={sentence} showTopDivider={index > 0} />
    ));
  }

  return {
    bodyKey: "morpheme-info-sentences-word-examples-body",
    headerKey: "morpheme-info-sentences-word-examples-header",
    iconName: "LuMessageSquare",
    isLoading,
    isOpen,
    onToggle: () => setIsOpen((previousState) => !previousState),
    renderBody: () => <View>{body}</View>,
    title: "Examples",
  };
}
